import { Controller } from "stimulus"
import Sortable from "sortablejs"

export default class extends Controller {    
  connect() {
    this.sortable = Sortable.create(this.element, {
    	chosenClass: "card-disabled",
    	handle: ".drag-handle",
    	onEnd: this.end.bind(this)
    })    
  }  

  end(event) {
  	let id = event.item.dataset.id    
  	let data = new FormData()
  	data.append("position", event.newIndex + 1)

  	Rails.ajax({
  		url: this.data.get("url").replace(":id", id),
  		type: 'PATCH',
  		data: data
  	})        

  	$(this.element).find('.drag-number').each(function (i) {
  		var number = i + 1;
    	$(this).html(number);
  	});    
  }
}
